import { BaseContainerModel } from '../base-container.model';
import { bl_wms_grn_attachment_RowInterface, bl_wms_grn_attachment_RowClass } from '../../dbschema/index';

export class WarehouseGrnAttachmentContainerModel extends BaseContainerModel {
    bl_wms_grn_attachment: bl_wms_grn_attachment_RowInterface = new bl_wms_grn_attachment_RowClass();
}
